export default __webpack_public_path__ + "static/media/darkBlueMarker.93a65a25.svg";